import { useContext, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Col, Container, Form, Row, Table, Modal } from 'react-bootstrap';
import { BsFileEarmarkPdf } from 'react-icons/bs';

import styles from './Chamado.module.css';
import { UserContext } from '../../context/UserContext';
import getChamadoById from '../../api/getChamadoById';
import { includeLeftZero } from '../../helpers/includeLeftZero';
import { formatDate } from '../../helpers/formatDate';
import { phoneMask } from '../../helpers/masks';
import updateChamado from '../../api/updateChamado';
import makePdf from '../../helpers/makePdf';
import { decrypt, decryptArray, encrypt } from '../../helpers/cryptography';
import pdfFerias from '../../helpers/pdfFeriasEmBranco';
import pdfAlteracaoFerias from '../../helpers/pdfAlteracaoFerias';
import generatePassword from '../../helpers/generatePassword';
import criarUsuario from '../../api/criarUsuario';
import forgotPassword from '../../api/forgotPassword';
import getExtension from '../../helpers/getExtension';
import pdfBriefing from '../../helpers/pdfBriefing';
import baseUrl from '../../api/baseUrl';
import { FaCopy } from 'react-icons/fa';
import useCopyToClipboard from '../../helpers/useCopyToClipboard';
import tiEmpresasResp from '../../helpers/tiEmpresasResp';
import { ErrorModal } from '../../components/ErrorModal';
import Loading from '../../components/Loading/index';

const radios = [
  { id: '0', nome: 'Sem acesso' },
  { id: '1', nome: 'Consulta' },
  { id: '2', nome: 'Gravação' },
  { id: '3', nome: 'Exclusão' },
];

const Chamado = props => {
  const obsRef = useRef(null);
  const { isAdmin, isResp, isUser } = useContext(UserContext);
  const history = useHistory();
  const [chamado, setChamado] = useState(null);
  const [finalAt, setFinalAt] = useState('');
  const [obs, setObs] = useState('');
  const [status, setStatus] = useState('');
  const [roles, setRoles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showFinalizarModal, setShowFinalizarModal] = useState(false);
  const [showModalObs, setShowModalObs] = useState(false);
  const [emailSugerido, setEmailSugerido] = useState('');
  const [emailSisged, setEmailSisged] = useState(false);
  const [copyToClipboard, { success }] = useCopyToClipboard();
  const [valuesToClipboard, setValuesToClipboard] = useState({});
  const [empresaResp, setEmpresaResp] = useState('');
  const [error, setError] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleEmpresaResp = e => {
    setEmpresaResp(e.target.value);
  };

  const handleFinalAt = e => {
    setFinalAt(e.target.value);
  };

  const handleObs = e => {
    setObs(e.target.value);
  };

  const handleCancelarSolicitacao = () => {
    const data = {
      finalAt: new Date(),
      obs,
      status: 'Cancelado',
      roles,
      email: chamado.email,
      responder: chamado.responder
    };

    const id = props.match.params.id;

    const upChamado = async () => {
      await updateChamado(id, data);

      history.push('/solicitacoes');
    };

    upChamado();

    setShowModal(false);
  };

  const handleFinalizarSolicitacao = () => {
    const data = {
      finalAt: new Date(),
      obs,
      status: 'Finalizado',
      roles,
      email: chamado.email,
      responder: chamado.responder,
      criacaoEmail: {
        ...chamado?.criacaoEmail,
        email: emailSugerido,
        sisged: emailSisged
      },
      suporteTi: {
        ...chamado?.suporteTi,
        empresaResp
      }
    };

    const id = props.match.params.id;

    const upChamado = async () => {
      await updateChamado(id, data);

      if (data.criacaoEmail.sisged) {
        if (chamado?.subcategoria === 'Criação de e-mail corporativo') {
          const dataUser = {
            name: decrypt(data.criacaoEmail.name),
            email: data.criacaoEmail.email + '@fesaude.niteroi.rj.gov.br',
            phone: decrypt(data.criacaoEmail.phone),
            unit: decrypt(data.criacaoEmail.unit),
            admissionDate: data.criacaoEmail.admissionDate,
            registration: decrypt(data.criacaoEmail.registration),
            sisged: emailSisged,
            roles: ['USER'],
            password: generatePassword(8)
          };

          await criarUsuario(dataUser);

          await forgotPassword(encrypt(dataUser.email));
        }
      }

      history.push('/solicitacoes');
    };

    upChamado();

    setShowFinalizarModal(false);
  };

  const handleStatus = e => {
    if (e.target.value === 'Cancelado') {
      if (isResp) {
        if (!obs) {
          setShowModalObs(true);

          return;
        }
      }

      if (isUser) {
        if (!obs) {
          setObs('Cancelado pelo usuário');
        } else {
          setObs(obs + ' - Cancelado pelo usuário');
        }
      }

      setShowModal(true);
    } else if (e.target.value === 'Finalizado') {
      setShowFinalizarModal(true);
    } else {
      setStatus(e.target.value);

      if (e.target.value === 'Aberto' || e.target.value === 'Em Andamento') {
        setFinalAt('');
      }
    }
  };

  const handleModalClose = () => {
    if (obs === 'Cancelado pelo usuário') {
      setObs('');
    }

    setShowModal(false);
  };

  const handleFinalizarModalClose = () => {
    setShowFinalizarModal(false);
  };

  const handleModalObsClose = () => {
    setShowModalObs(false);
  };

  useEffect(() => {
    const getChamado = async () => {
      setIsLoading(true);

      const login = JSON.parse(localStorage.getItem('login'));
      const roles = decryptArray(login?.user?.roles);
      const id = props.match.params.id;
      const chamadoAtual = await getChamadoById(id);

      setChamado(chamadoAtual);
      setFinalAt(chamadoAtual?.finalAt);
      setObs(chamadoAtual?.obs);
      setStatus(chamadoAtual?.status);
      setRoles(roles);

      if (chamadoAtual?.loginSistemas?.tipo === 'login') {
        setValuesToClipboard(chamadoAtual?.loginSistemas);
      }

      if (chamadoAtual?.criacaoEmail?.email) {
        try {
          const emailSugeridoDecrypt = decrypt(chamadoAtual?.criacaoEmail?.email);

          if (emailSugeridoDecrypt) {
            setEmailSugerido(emailSugeridoDecrypt);
          }
        } catch (error) {
          console.log('Erro ao descriptografar e-mail sugerido');

          setEmailSugerido(chamadoAtual?.criacaoEmail?.email);
        }
      }

      if (chamadoAtual?.criacaoEmail) {
        setEmailSisged(chamadoAtual?.criacaoEmail?.sisged);
      }

      setIsLoading(false);
    };

    getChamado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEmailSugerido = e => {
    setEmailSugerido(e.target.value);
  };

  const handleEmailSisged = e => {
    setEmailSisged(e.target.value);
  };

  const handlePdf = () => {
    if (chamado.subcategoria === 'Solicitação de férias') {
      chamado.solicitacaoFerias.cargo = decrypt(chamado.solicitacaoFerias.cargo);
      chamado.solicitacaoFerias.lotacao = decrypt(chamado.solicitacaoFerias.lotacao);
      chamado.solicitacaoFerias.matricula = decrypt(chamado.solicitacaoFerias.matricula);
      chamado.solicitacaoFerias.nome = decrypt(chamado.solicitacaoFerias.nome);

      pdfFerias(chamado.solicitacaoFerias);
    } else if (chamado.subcategoria === 'Alteração de férias') {
      if (chamado.alteracaoFerias) {
        chamado.alteracaoFerias.cargo = decrypt(chamado.alteracaoFerias.cargo);
        chamado.alteracaoFerias.lotacao = decrypt(chamado.alteracaoFerias.lotacao);
        chamado.alteracaoFerias.matricula = decrypt(chamado.alteracaoFerias.matricula);
        chamado.alteracaoFerias.nome = decrypt(chamado.alteracaoFerias.nome);

        pdfAlteracaoFerias(chamado.alteracaoFerias);
      }
    } else if (chamado.subcategoria === 'Formulário de Criação') {
      pdfBriefing(chamado);
    } else {
      makePdf(chamado);
    }
  };

  const copyValuesToClipboard = async values => {
    const text = `tipo: ${values?.tipo ? values?.tipo : ''}
sistema: ${values?.sistema ? values?.sistema : ''}
unidade: ${values?.unidade ? values?.unidade : ''}
nome: ${values?.nome ? decrypt(values?.nome) : ''}
cpf: ${values?.cpf ? decrypt(values?.cpf) : ''}
cns: ${values?.cns ? decrypt(values?.cns) : ''}
email: ${values?.email ? decrypt(values?.email) : ''}
telefone: ${values?.telefone ? decrypt(values?.telefone) : ''}`;

    copyToClipboard(text);
  };

  const handleSubmit = event => {
    event.preventDefault();

    if ((isResp && chamado?.categoria === 'Suporte de TI') && (!empresaResp && !chamado?.suporteTi?.empresaResp)) {
      setError('O campo "Empresa Responsável" é obrigatório');
      setShowErrorModal(true);

      return;
    }

    const empresaRespAtual = chamado?.suporteTi?.empresaResp ? chamado?.suporteTi?.empresaResp : empresaResp;

    const data = {
      finalAt,
      obs,
      status,
      roles,
      email: chamado.email,
      responder: chamado.responder,
      criacaoEmail: {
        ...chamado?.criacaoEmail,
        email: emailSugerido,
        sisged: emailSisged
      },
      suporteTi: {
        ...chamado?.suporteTi,
        empresaResp: empresaRespAtual
      }
    };

    const id = props.match.params.id;

    const upChamado = async () => {
      await updateChamado(id, data);

      //history.push('/solicitacoes');
      history.goBack();
    };

    upChamado();
  };

  return (
    <Container className={styles.container}>
      {isLoading && <Loading />}

      {!isLoading && (
        <>
          <div className={styles.title_container}>
            <div className={styles.title}>
              Solicitação {includeLeftZero(chamado?.numeroChamado)}
            </div>
            {chamado?.subcategoria !== 'Formulário de Inscrição CIPAA' && (
              <Button variant="danger" className={styles.button_pdf} onClick={handlePdf}>
                <BsFileEarmarkPdf className={styles.icon_pdf} /> PDF
              </Button>
            )}
          </div>
          <Form
            onSubmit={handleSubmit}
            noValidate
          >
            <Form.Group className="mt-4">
              <Form.Label>*e-mail:</Form.Label>
              <Form.Control
                type="email"
                required
                name="email"
                value={chamado?.email || ''}
                readOnly
              />
            </Form.Group>

            <Row>
              <Col sm={7}>
                <Form.Group className="mt-4">
                  <Form.Label>*Nome do Solicitante:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="nome"
                    value={chamado?.nome || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>

              <Col sm={5}>
                <Form.Group className="mt-4">
                  <Form.Label>*Telefone:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="telefone"
                    value={chamado?.telefone || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm={12}>
                <Form.Group className="mt-4">
                  <Form.Label>*Unidade:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="unidade"
                    value={chamado?.unidade || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <Form.Group className="mt-4">
                  <Form.Label>*Categoria:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="categoria"
                    value={chamado?.categoria || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>

              <Col sm={6}>
                <Form.Group className="mt-4">
                  <Form.Label>*Subcategoria:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="subcategoria"
                    value={chamado?.subcategoria || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>
            </Row>

            {chamado?.materiaisEscritorio.length > 0 && (
              <Table responsive striped bordered className={styles.table}>
                <thead>
                  <tr>
                    <th style={{ width: '85%' }}>Materiais de Escritório</th>
                    <th style={{ width: '15%' }}>Qtde</th>
                  </tr>
                </thead>

                <tbody>
                  {chamado?.materiaisEscritorio.map((item, index) => (
                    <tr key={`${item.material}-${index}`}>
                      <td>
                        <Form.Group className="mt-4">
                          <Form.Control
                            className={styles.td}
                            type="text"
                            name="material"
                            value={item.material || ''}
                            readOnly
                          />
                        </Form.Group>
                      </td>
                      <td>
                        <Form.Group className="mt-4">
                          <Form.Control
                            className={styles.td}
                            type="text"
                            name="quantidade"
                            value={item.quantidade || ''}
                            readOnly
                          />
                        </Form.Group>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            {chamado?.materiaisLimpeza.length > 0 && (
              <Table responsive striped bordered className={styles.table}>
                <thead>
                  <tr>
                    <th style={{ width: '85%' }}>Materiais de Limpeza</th>
                    <th style={{ width: '15%' }}>Qtde</th>
                  </tr>
                </thead>

                <tbody>
                  {chamado?.materiaisLimpeza.map((item, index) => (
                    <tr key={`${item.material}-${index}`}>
                      <td>
                        <Form.Group className="mt-4">
                          <Form.Control
                            className={styles.td}
                            type="text"
                            name="material"
                            value={item.material || ''}
                            readOnly
                          />
                        </Form.Group>
                      </td>
                      <td>
                        <Form.Group className="mt-4">
                          <Form.Control
                            className={styles.td}
                            type="text"
                            name="quantidade"
                            value={item.quantidade || ''}
                            readOnly
                          />
                        </Form.Group>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            {chamado?.materiaisExpediente.length > 0 && (
              <Table responsive striped bordered className={styles.table}>
                <thead>
                  <tr>
                    <th style={{ width: '85%' }}>Materiais de Expediente</th>
                    <th style={{ width: '15%' }}>Qtde</th>
                  </tr>
                </thead>

                <tbody>
                  {chamado?.materiaisExpediente.map((item, index) => (
                    <tr key={`${item.material}-${index}`}>
                      <td>
                        <Form.Group className="mt-4">
                          <Form.Control
                            className={styles.td}
                            type="text"
                            name="material"
                            value={item.material || ''}
                            readOnly
                          />
                        </Form.Group>
                      </td>
                      <td>
                        <Form.Group className="mt-4">
                          <Form.Control
                            className={styles.td}
                            type="text"
                            name="quantidade"
                            value={item.quantidade || ''}
                            readOnly
                          />
                        </Form.Group>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            {chamado?.criacaoEmail?.email && (
              <>
                <Row className="mt-4">
                  <Col sm={4}>
                    <Form.Group controlId="registration">
                      <Form.Label>*Matrícula:</Form.Label>
                      <Form.Control
                        autoComplete="nope"
                        required
                        type="text"
                        name="registration"
                        value={chamado.criacaoEmail.registration ? decrypt(chamado?.criacaoEmail?.registration) : ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={8}>
                    <Form.Group controlId="name">
                      <Form.Label>*Nome:</Form.Label>
                      <Form.Control
                        autoComplete="nope"
                        type="text"
                        required
                        name="name"
                        value={chamado.criacaoEmail.name ? decrypt(chamado?.criacaoEmail?.name) : ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>


                <Row className="mt-4">
                  <Col sm={8} style={{ paddingRight: 0 }}>
                    <Form.Group controlId="email">
                      <Form.Label>*e-mail sugerido:</Form.Label>
                      <Form.Control
                        autoComplete="nope"
                        type="text"
                        required
                        name="email"
                        onChange={e => handleEmailSugerido(e)}
                        value={emailSugerido}
                        readOnly={isResp ? false : true}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={4} style={{ paddingLeft: 0 }}>
                    <Form.Group>
                      <Form.Label>&nbsp;</Form.Label>
                      <Form.Control
                        autoComplete="nope"
                        type="text"
                        readOnly
                        value="@fesaude.niteroi.rj.gov.br"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col sm={6}>
                    <Form.Group controlId="phone">
                      <Form.Label>*Telefone:</Form.Label>
                      <Form.Control
                        autoComplete="nope"
                        type="text"
                        required
                        name="phone"
                        placeholder="(21) 99999-9999"
                        value={chamado.criacaoEmail.phone ? decrypt(chamado?.criacaoEmail?.phone) : ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group controlId="admissionDate">
                      <Form.Label>*Data de admissão:</Form.Label>
                      <Form.Control
                        autoComplete="nope"
                        required
                        type="text"
                        name="admissionDate"
                        value={chamado.criacaoEmail.admissionDate ? formatDate(chamado?.criacaoEmail?.admissionDate) : ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col sm={12}>
                    <Form.Group controlId="unit">
                      <Form.Label>*Unidade:</Form.Label>
                      <Form.Control
                        autoComplete="nope"
                        type="text"
                        required
                        name="unit"
                        value={chamado.criacaoEmail.unit ? decrypt(chamado?.criacaoEmail?.unit) : ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col sm={12}>
                    <Form.Group controlId="job">
                      <Form.Label>*Cargo:</Form.Label>
                      <Form.Control
                        autoComplete="nope"
                        required
                        type="text"
                        name="job"
                        value={chamado.criacaoEmail.job ? decrypt(chamado?.criacaoEmail?.job) : ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col sm={12}>
                    <Form.Group controlId="sisged">
                      <Form.Label>*Criar usuário no SisGeD?</Form.Label>
                      <Form.Select
                        autoComplete="nope"
                        className="border border-secondary"
                        required
                        name="sisged"
                        onChange={e => handleEmailSisged(e)}
                        value={emailSisged}
                        disabled={isResp ? false : true}
                      >
                        <option value={true}>Sim</option>
                        <option value={false}>Não</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {chamado?.solicitacaoVeiculo && (
              <>
                <Row>
                  <Col sm={4}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Data do transporte:</Form.Label>
                      <Form.Control
                        type="text"
                        name="veiculoData"
                        value={formatDate(chamado?.solicitacaoVeiculo?.veiculoData) || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={4}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Hora do transporte:</Form.Label>
                      <Form.Control
                        type="text"
                        name="veiculoHora"
                        value={chamado?.solicitacaoVeiculo?.veiculoHora || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={4}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Tempo estimado:</Form.Label>
                      <Form.Control
                        type="text"
                        name="veiculoTempo"
                        value={chamado?.solicitacaoVeiculo?.veiculoTempo || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={6}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Nome do passageiro:</Form.Label>
                      <Form.Control
                        type="text"
                        name="veiculoPassageiro"
                        value={chamado?.solicitacaoVeiculo?.veiculoPassageiro || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Telefone do passageiro:</Form.Label>
                      <Form.Control
                        type="text"
                        name="veiculoTelefone"
                        value={phoneMask(chamado?.solicitacaoVeiculo?.veiculoTelefone) || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Endereço da saída:</Form.Label>
                      <Form.Control
                        type="text"
                        name="veiculoSaida"
                        value={chamado?.solicitacaoVeiculo?.veiculoSaida || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Endereço do destino:</Form.Label>
                      <Form.Control
                        type="text"
                        name="veiculoDestino"
                        value={chamado?.solicitacaoVeiculo?.veiculoDestino || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {chamado?.solicitacaoMotoboy && (
              <>
                <Row>
                  <Col sm={4}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Data do transporte:</Form.Label>
                      <Form.Control
                        type="text"
                        name="motoboyData"
                        value={formatDate(chamado?.solicitacaoMotoboy?.motoboyData) || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={4}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Hora do transporte:</Form.Label>
                      <Form.Control
                        type="text"
                        name="motoboyHora"
                        value={chamado?.solicitacaoMotoboy?.motoboyHora || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={4}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Tempo estimado:</Form.Label>
                      <Form.Control
                        type="text"
                        name="motoboyTempo"
                        value={chamado?.solicitacaoMotoboy?.motoboyTempo || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={6}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Nome do passageiro:</Form.Label>
                      <Form.Control
                        type="text"
                        name="motoboyPassageiro"
                        value={chamado?.solicitacaoMotoboy?.motoboyPassageiro || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Telefone do passageiro:</Form.Label>
                      <Form.Control
                        type="text"
                        name="motoboyTelefone"
                        value={phoneMask(chamado?.solicitacaoMotoboy?.motoboyTelefone) || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Endereço da saída:</Form.Label>
                      <Form.Control
                        type="text"
                        name="motoboySaida"
                        value={chamado?.solicitacaoMotoboy?.motoboySaida || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group className="mt-4">
                      <Form.Label>*Endereço do destino:</Form.Label>
                      <Form.Control
                        type="text"
                        name="motoboyDestino"
                        value={chamado?.solicitacaoMotoboy?.motoboyDestino || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {chamado?.equipamentoEngenhariaClinica && (
              <Row>
                <Col sm={12}>
                  <Form.Group controlId="equipamentoEngenhariaClinica" className="mt-4">
                    <Form.Label>*Equipamento:</Form.Label>
                    <Form.Control
                      type="text"
                      name="equipamentoEngenhariaClinica"
                      value={chamado?.equipamentoEngenhariaClinica || ''}
                      readOnly
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {chamado?.categoria === 'Suporte de TI' && (
              <Row>
                <Col sm={6}>
                  <Form.Group controlId="telContatoTi" className="mt-4">
                    <Form.Label>Telefone de Contato:</Form.Label>
                    <Form.Control
                      type="text"
                      name="telContatoTi"
                      value={chamado?.suporteTi?.telContatoTi || ''}
                      readOnly
                    />
                  </Form.Group>
                </Col>

                <Col sm={6}>
                  <Form.Group controlId="patrimonioTi" className="mt-4">
                    <Form.Label>Patrimônio:</Form.Label>
                    <Form.Control
                      type="text"
                      name="patrimonioTi"
                      value={chamado?.suporteTi?.patrimonioTi || ''}
                      readOnly
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {chamado?.pontoEletronico?.assunto && (
              <Row>
                <Col sm={12}>
                  <Form.Group controlId="pontoEletronico" className="mt-4">
                    <Form.Label>*Assunto:</Form.Label>
                    <Form.Control
                      type="text"
                      name="pontoEletronico"
                      value={chamado?.pontoEletronico?.assunto || ''}
                      readOnly
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {chamado?.loginSistemas?.sistema && (
              <>
                <Row className={styles.title_sistemas}>Sistemas de Saúde</Row>
                <Row className={styles.options_sistemas}>
                  <Row className={styles.subtitle_sistemas}>*Login ou Suporte?</Row>
                  <Row>
                    <Col sm={12}>
                      <Form.Check
                        className={styles.checkbox}
                        type="radio"
                        label="Login"
                        value="login"
                        name="tipo"
                        id="login"
                        inline
                        readOnly
                        checked={chamado?.loginSistemas?.tipo === 'login'}
                      />
                      <Form.Check
                        className={styles.checkbox_sistemas}
                        type="radio"
                        label="Suporte"
                        value="suporte"
                        name="tipo"
                        id="suporte"
                        inline
                        readOnly
                        checked={chamado?.loginSistemas?.tipo === 'suporte'}
                      />
                    </Col>
                  </Row>
                </Row>

                <Row>
                  <Col sm={6}>
                    <Form.Group controlId="loginSistemas" className="mt-4">
                      <Form.Label>*Sistema:</Form.Label>
                      <Form.Control
                        type="text"
                        name="loginSistemas"
                        value={chamado?.loginSistemas?.sistema || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {chamado?.loginSistemas?.tipo === 'login' && (
                  <>
                    <Row>
                      <Col sm={6}>
                        <Form.Group controlId="loginSistemas" className="mt-4">
                          <Form.Label>*Unidade:</Form.Label>
                          <Form.Control
                            type="text"
                            name="loginSistemas"
                            value={chamado?.loginSistemas?.unidade || ''}
                            readOnly
                          />
                        </Form.Group>
                      </Col>

                      <Col sm={6}>
                        <Form.Group controlId="nome" className="mt-4">
                          <Form.Label>*Nome Completo:</Form.Label>
                          <Form.Control
                            type="text"
                            name="nome"
                            value={chamado?.loginSistemas?.nome ? decrypt(chamado?.loginSistemas?.nome) : ''}
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={6}>
                        <Form.Group controlId="cpf" className="mt-4">
                          <Form.Label>*CPF:</Form.Label>
                          <Form.Control
                            type="text"
                            name="cpf"
                            value={chamado?.loginSistemas?.cpf ? decrypt(chamado?.loginSistemas?.cpf) : ''}
                            readOnly
                          />
                        </Form.Group>
                      </Col>

                      <Col sm={6}>
                        <Form.Group controlId="cns" className="mt-4">
                          <Form.Label>*CNS:</Form.Label>
                          <Form.Control
                            type="text"
                            name="cns"
                            value={chamado?.loginSistemas?.cns ? decrypt(chamado?.loginSistemas?.cns) : ''}
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={6}>
                        <Form.Group controlId="email" className="mt-4">
                          <Form.Label>*e-mail:</Form.Label>
                          <Form.Control
                            type="text"
                            name="email"
                            value={chamado?.loginSistemas?.email ? decrypt(chamado?.loginSistemas?.email) : ''}
                            readOnly
                          />
                        </Form.Group>
                      </Col>

                      <Col sm={6}>
                        <Form.Group controlId="telefone" className="mt-4">
                          <Form.Label>*Telefone:</Form.Label>
                          <Form.Control
                            type="text"
                            name="telefone"
                            value={chamado?.loginSistemas?.telefone ? decrypt(chamado?.loginSistemas?.telefone) : ''}
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <div className={styles.clipboard_container}>
                      <Button
                        variant="flat"
                        className={styles.button_list}
                        onClick={() => copyValuesToClipboard(valuesToClipboard)}
                      >
                        <FaCopy className={styles.icon_list} /> {success ? 'Copiado' : 'Copiar'}
                      </Button>
                    </div>

                    <Row>
                      <Col sm={12}>
                        <Form.Group>
                          <Form.Label>Resumo:</Form.Label>
                          <Form.Control
                            className="border border-secondary"
                            as="textarea"
                            rows={8}
                            value={`${chamado?.loginSistemas?.tipo ? 'tipo: ' + chamado?.loginSistemas?.tipo : ''}
${chamado?.loginSistemas?.sistema ? 'sistema: ' + chamado?.loginSistemas?.sistema : ''}
${chamado?.loginSistemas?.unidade ? 'unidade: ' + chamado?.loginSistemas?.unidade : ''}
${chamado?.loginSistemas?.nome ? 'nome: ' + decrypt(chamado?.loginSistemas?.nome) : ''}
${chamado?.loginSistemas?.cpf ? 'cpf: ' + decrypt(chamado?.loginSistemas?.cpf) : ''}
${chamado?.loginSistemas?.cns ? 'cns: ' + decrypt(chamado?.loginSistemas?.cns) : ''}
${chamado?.loginSistemas?.email ? 'email: ' + decrypt(chamado?.loginSistemas?.email) : ''}
${chamado?.loginSistemas?.telefone ? 'telefone: ' + decrypt(chamado?.loginSistemas?.telefone) : ''}`}
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}

                {chamado?.loginSistemas?.tipo === 'suporte' && chamado?.loginSistemas?.suporteArquivos?.length > 0 && (
                  chamado?.loginSistemas?.suporteArquivos.map(item => {
                    return (
                      <Row key={item.fileName} className={`${styles.files} mt-2`}>
                        <Col sm={12}>
                          {getExtension(item.fileName) === 'pdf' &&
                            <img
                              src='../../assets/img/pdf.jpeg'
                              alt={item.fileName}
                              className={styles.file_thumb}
                            />
                          }

                          {(getExtension(item.fileName) === 'doc' || getExtension(item.fileName) === 'docx') &&
                            <img
                              src='../../assets/img/word.png'
                              alt={item.fileName}
                              className={styles.file_thumb}
                            />
                          }

                          {(getExtension(item.fileName) === 'xls' || getExtension(item.fileName) === 'xlsx') &&
                            <img
                              src='../../assets/img/excel.jpeg'
                              alt={item.fileName}
                              className={styles.file_thumb}
                            />
                          }

                          {getExtension(item.fileName) === 'txt' &&
                            <img
                              src='../../assets/img/txt.png'
                              alt={item.fileName}
                              className={styles.file_thumb}
                            />
                          }

                          {getExtension(item.fileName) === 'mp4' &&
                            <img
                              src='../../assets/img/mp4.png'
                              alt={item.fileName}
                              className={styles.file_thumb}
                            />
                          }

                          {getExtension(item.fileName) === 'avi' &&
                            <img
                              src='../../assets/img/avi.png'
                              alt={item.fileName}
                              className={styles.file_thumb}
                            />
                          }

                          {getExtension(item.fileName) === 'mov' &&
                            <img
                              src='../../assets/img/mov.png'
                              alt={item.fileName}
                              className={styles.file_thumb}
                            />
                          }

                          {
                            getExtension(item.fileName) !== 'pdf' &&
                            getExtension(item.fileName) !== 'doc' &&
                            getExtension(item.fileName) !== 'docx' &&
                            getExtension(item.fileName) !== 'xls' &&
                            getExtension(item.fileName) !== 'xlsx' &&
                            getExtension(item.fileName) !== 'txt' &&
                            getExtension(item.fileName) !== 'mp4' &&
                            getExtension(item.fileName) !== 'avi' &&
                            getExtension(item.fileName) !== 'mov' &&
                            <img
                              src={`${baseUrl}/suporte/upload/${item.fileName}`}
                              alt={item.fileName}
                              className={styles.file_thumb}
                            />
                          }

                          <a
                            href={`${baseUrl}/suporte/upload/${item.fileName}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.originalName}
                          </a>
                        </Col>
                      </Row>
                    );
                  })
                )}
              </>
            )}

            {chamado?.briefing && (
              <>
                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="briefingPorque" className="mt-4">
                      <Form.Label>*O que precisamos fazer? Por que você está fazendo esse pedido?</Form.Label>
                      <Form.Control
                        className="border border-secondary"
                        as="textarea"
                        rows={7}
                        name="briefingPorque"
                        value={chamado?.briefing?.briefingPorque || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="briefingMedidas" className="mt-4">
                      <Form.Label>*Quais peças devem ser desenvolvidas/criadas? Quais as medidas (largura X altura)?</Form.Label>
                      <Form.Control
                        className="border border-secondary"
                        as="textarea"
                        rows={7}
                        name="briefingMedidas"
                        value={chamado?.briefing?.briefingMedidas || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="briefingOnde" className="mt-4">
                      <Form.Label>*Onde serão veiculadas/expostas? (Redes sociais, portal, impressos, eventos etc.)</Form.Label>
                      <Form.Control
                        className="border border-secondary"
                        as="textarea"
                        rows={7}
                        name="briefingOnde"
                        value={chamado?.briefing?.briefingOnde || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="briefingPrazo" className="mt-4">
                      <Form.Label>*Qual é o prazo final para entrega do projeto? Sujeito a análise interna e viabilidade dos pedidos na fila de produção.</Form.Label>
                      <Form.Control
                        type="text"
                        className="border border-secondary"
                        name="briefingPrazo"
                        value={formatDate(chamado?.briefing?.briefingPrazo) || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="briefingDetalhe" className="mt-4">
                      <Form.Label>*Tem mais algum detalhe ou algum link de referência? Deixe aqui o seu comentário para inspirar a nossa equipe.</Form.Label>
                      <Form.Control
                        className="border border-secondary"
                        as="textarea"
                        rows={7}
                        name="briefingDetalhe"
                        value={chamado?.briefing?.briefingDetalhe || ''}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {chamado?.briefing?.briefingArquivos?.length > 0 && (
                  (chamado?.status === 'Aberto' || chamado?.status === 'Em Andamento') && (
                    <>
                      <Row>
                        <p className={styles.file_title}>
                          Tem algum arquivo (foto, texto ou logo) que precisamos receber? Envie anexo. (Máximo de 5 anexos com 5MB cada) <br />
                          Arquivos suportados: .pdf, .png, .gif, .jpg, .jpeg, .svg, .txt, .doc, .docx, .xls, .xlsx
                        </p>
                      </Row>

                      {chamado?.briefing?.briefingArquivos?.map(item => {
                        return (
                          <Row key={item.fileName} className={styles.files}>
                            <Col sm={12}>
                              {getExtension(item.fileName) === 'pdf' &&
                                <img
                                  src='../../assets/img/pdf.jpeg'
                                  alt={item.fileName}
                                  className={styles.file_thumb}
                                />
                              }

                              {(getExtension(item.fileName) === 'doc' || getExtension(item.fileName) === 'docx') &&
                                <img
                                  src='../../assets/img/word.png'
                                  alt={item.fileName}
                                  className={styles.file_thumb}
                                />
                              }

                              {(getExtension(item.fileName) === 'xls' || getExtension(item.fileName) === 'xlsx') &&
                                <img
                                  src='../../assets/img/excel.jpeg'
                                  alt={item.fileName}
                                  className={styles.file_thumb}
                                />
                              }

                              {getExtension(item.fileName) === 'txt' &&
                                <img
                                  src='../../assets/img/txt.png'
                                  alt={item.fileName}
                                  className={styles.file_thumb}
                                />
                              }

                              {
                                getExtension(item.fileName) !== 'pdf' &&
                                getExtension(item.fileName) !== 'doc' &&
                                getExtension(item.fileName) !== 'docx' &&
                                getExtension(item.fileName) !== 'xls' &&
                                getExtension(item.fileName) !== 'xlsx' &&
                                getExtension(item.fileName) !== 'txt' &&

                                <img
                                  src={`${baseUrl}/ascom/upload/${item.fileName}`}
                                  alt={item.fileName}
                                  className={styles.file_thumb}
                                />
                              }

                              <a
                                href={`${baseUrl}/ascom/upload/${item.fileName}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {item.originalName}
                              </a>
                            </Col>
                          </Row>
                        )
                      })}
                    </>
                  )
                )}

                {chamado?.briefing?.briefingArquivos?.length > 0 && (
                  (chamado?.status === 'Cancelado' || chamado?.status === 'Finalizado') && (
                    <>
                      <Row>
                        <p className={styles.file_title}>
                          Tem algum arquivo (foto, texto ou logo) que precisamos receber? Envie anexo. (Máximo de 5 anexos com 5MB cada) <br />
                          Arquivos suportados: .pdf, .png, .gif, .jpg, .jpeg, .svg, .txt, .doc, .docx, .xls, .xlsx
                        </p>
                      </Row>

                      {chamado?.briefing?.briefingArquivos?.map(item => {
                        return (
                          <Row key={item.fileName} className={styles.files}>
                            <Col sm={12}>
                              {item.fileName} &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp; {item.originalName}
                            </Col>
                          </Row>
                        )
                      })}
                    </>
                  )
                )}
              </>
            )}

            {chamado?.subcategoria === 'ERP - (MXM)' && (
              <>
                <Row className={styles.title_erp}>ERP - (MXM)</Row>

                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="erpNome" className="mt-4">
                      <Form.Label>*Nome completo:</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        name="erpNome"
                        value={chamado?.erp?.erpNome}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="erpEmail" className="mt-4">
                      <Form.Label>*e-mail:</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        name="erpEmail"
                        value={chamado?.erp?.erpEmail}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="erpMatricula" className="mt-4">
                      <Form.Label>*Matrícula:</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        required
                        name="erpMatricula"
                        value={chamado?.erp?.erpMatricula}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <Form.Group controlId="erpUnidade" className="mt-4 mb-5">
                      <Form.Label>*Unidade:</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        required
                        name="erpUnidade"
                        value={chamado?.erp?.erpUnidade}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpAdministrador' className="mt-2">
                      <Form.Label className={styles.confirm}>Administrador:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpAdministrador === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpAdministrador'
                            type="radio"
                            id={`erpAdministrador-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpCadastrosComuns' className="mt-1">
                      <Form.Label className={styles.confirm}>Cadastros Comuns:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpCadastrosComuns === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpCadastrosComuns'
                            type="radio"
                            id={`erpCadastrosComuns-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpCadastrosComumFinanceiro' className="mt-1">
                      <Form.Label className={styles.confirm}>Cadastros Comum Financeiro:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpCadastrosComumFinanceiro === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpCadastrosComumFinanceiro'
                            type="radio"
                            id={`erpCadastrosComumFinanceiro-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpGestaoDeProcessos' className="mt-1">
                      <Form.Label className={styles.confirm}>Gestão de Processos:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpGestaoDeProcessos === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpGestaoDeProcessos'
                            type="radio"
                            id={`erpGestaoDeProcessos-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpCompras' className="mt-1">
                      <Form.Label className={styles.confirm}>Compras:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpCompras === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpCompras'
                            type="radio"
                            id={`erpCompras-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpContratoCompras' className="mt-1">
                      <Form.Label className={styles.confirm}>Contrato Compras:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpContratoCompras === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpContratoCompras'
                            type="radio"
                            id={`erpContratoCompras-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpContasPagar' className="mt-1">
                      <Form.Label className={styles.confirm}>Contas Pagar:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpContasPagar === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpContasPagar'
                            type="radio"
                            id={`erpContasPagar-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpPagamentoEscritural' className="mt-1">
                      <Form.Label className={styles.confirm}>Pagamento Escritural:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpPagamentoEscritural === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpPagamentoEscritural'
                            type="radio"
                            id={`erpPagamentoEscritural-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpContasReceber' className="mt-1">
                      <Form.Label className={styles.confirm}>Contas Receber:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpContasReceber === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpContasReceber'
                            type="radio"
                            id={`erpContasReceber-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpTesouraria' className="mt-1">
                      <Form.Label className={styles.confirm}>Tesouraria:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpTesouraria === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpTesouraria'
                            type="radio"
                            id={`erpTesouraria-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpIntegracaoPadrao' className="mt-1">
                      <Form.Label className={styles.confirm}>Integração Padrão:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpIntegracaoPadrao === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpIntegracaoPadrao'
                            type="radio"
                            id={`erpIntegracaoPadrao-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpContabil' className="mt-1">
                      <Form.Label className={styles.confirm}>Contábil:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpContabil === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpContabil'
                            type="radio"
                            id={`erpContabil-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpEstoque' className="mt-1">
                      <Form.Label className={styles.confirm}>Estoque:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpEstoque === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpEstoque'
                            type="radio"
                            id={`erpEstoque-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpPatrimonio' className="mt-1">
                      <Form.Label className={styles.confirm}>Patrimônio:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpPatrimonio === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpPatrimonio'
                            type="radio"
                            id={`erpPatrimonio-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpOrcamento' className="mt-1">
                      <Form.Label className={styles.confirm}>Orçamento:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpOrcamento === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpOrcamento'
                            type="radio"
                            id={`erpOrcamento-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpReinf' className="mt-1">
                      <Form.Label className={styles.confirm}>REINF:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpReinf === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpReinf'
                            type="radio"
                            id={`erpReinf-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpEfd' className="mt-1">
                      <Form.Label className={styles.confirm}>EFD:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpEfd === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpEfd'
                            type="radio"
                            id={`erpEfd-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpEcd' className="mt-1">
                      <Form.Label className={styles.confirm}>ECD:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpEcd === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpEcd'
                            type="radio"
                            id={`erpEcd-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className={styles.bg_color}>
                  <Col sm={12}>
                    <Form.Group controlId='erpEcf' className="mt-1">
                      <Form.Label className={styles.confirm}>ECF:</Form.Label>
                      {radios.map(item => {
                        return (
                          <Form.Check
                            disabled
                            key={item.id}
                            value={`${item.id} - ${item.nome}`}
                            checked={chamado?.erp?.erpEcf === `${item.id} - ${item.nome}`}
                            className={styles.radio}
                            inline
                            label={`${item.id} - ${item.nome}`}
                            name='erpEcf'
                            type="radio"
                            id={`erpEcf-${item.id}`}
                          />
                        );
                      })}
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {isResp && chamado?.categoria === 'Suporte de TI' && (
              <Row className="mt-4">
                <Col sm={12}>
                  <Form.Group controlId="empresaResp">
                    <Form.Label>*Empresa Responsável:</Form.Label>
                    <Form.Select
                      className="border border-secondary"
                      name="empresaResp"
                      onChange={handleEmpresaResp}
                      value={empresaResp}
                    >
                      {chamado?.suporteTi?.empresaResp ? (
                        <option value={chamado?.suporteTi?.empresaResp}>{chamado?.suporteTi?.empresaResp}</option>
                      ) : (
                        <option value="">Selecione a Empresa Responsável</option>
                      )}
                      {tiEmpresasResp.map(item => (
                        <option key={item} value={item}>{item}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            )}

            {(chamado?.subcategoria !== 'Briefing para Criação' && chamado?.subcategoria !== 'Formulário de Inscrição CIPAA' && chamado?.subcategoria !== 'ERP - (MXM)') &&
              <Row>
                <Col sm={12}>
                  <Form.Group className="mt-4">
                    <Form.Label>*Descreva brevemente a solicitação:</Form.Label>
                    <Form.Control
                      className="border border-secondary"
                      required
                      as="textarea"
                      rows={5}
                      name="relato"
                      value={chamado?.relato || ''}
                      readOnly
                    />
                  </Form.Group>
                </Col>
              </Row>
            }

            <Row>
              <Col sm={4}>
                <Form.Group className="mt-4">
                  <Form.Label>*SLA:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="sla"
                    value={chamado?.sla || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>

              <Col sm={4}>
                <Form.Group className="mt-4">
                  <Form.Label>*Data Inicial:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="dataInicial"
                    value={formatDate(chamado?.createdAt) || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>

              <Col sm={4}>
                <Form.Group controlId="finalAt" className="mt-4">
                  <Form.Label>*Data Final:</Form.Label>
                  <Form.Control
                    type="text"
                    name="finalAt"
                    onChange={e => handleFinalAt(e)}
                    value={finalAt ? formatDate(finalAt) : ''}
                    readOnly
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm={4}>
                <Form.Group controlId="status" className="mt-4 mb-5">
                  <Form.Label>*Status atual:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="status"
                    value={status || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>
              <Col sm={8}>
                <Form.Group className="mt-4">
                  {((!isAdmin && !isResp) && (status === 'Aberto')) && (
                    <Form.Label className="d-block">Alterar Status:</Form.Label>
                  )}

                  {((isAdmin || isResp) && (status === 'Aberto' || status === 'Em Andamento')) && (
                    <Form.Label className="d-block">Alterar Status:</Form.Label>
                  )}

                  {((isAdmin || isResp) && (status === 'Aberto' || status === 'Em Andamento')) && (
                    <>
                      <Button
                        className={styles.buttons}
                        variant="warning"
                        value="Em Andamento"
                        onClick={e => handleStatus(e)}
                      >
                        Em Andamento
                      </Button>
                      <Button
                        className={styles.buttons}
                        variant="success"
                        value="Finalizado"
                        onClick={e => handleStatus(e)}
                      >
                        Finalizado
                      </Button>
                      <Button
                        className={styles.buttons}
                        variant="secondary"
                        value="Cancelado"
                        onClick={e => handleStatus(e)}
                      >
                        Cancelado
                      </Button>
                    </>
                  )}

                  {((!isAdmin && !isResp) && (status === 'Aberto')) && (
                    <Button
                      className={styles.buttons}
                      variant="secondary"
                      value="Cancelado"
                      onClick={e => handleStatus(e)}
                    >
                      Cancelado
                    </Button>
                  )}
                </Form.Group>
              </Col>
              <Modal show={showModal} onHide={handleModalClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Cancelar Solicitação</Modal.Title>
                </Modal.Header>
                <Modal.Body>Tem certeza que deseja cancelar a solicitação?</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleModalClose}>
                    Não
                  </Button>
                  <Button variant="flat" className={styles.btn} onClick={handleCancelarSolicitacao}>
                    Sim
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal show={showFinalizarModal} onHide={handleFinalizarModalClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Finalizar Solicitação</Modal.Title>
                </Modal.Header>
                <Modal.Body>Tem certeza que deseja finalizar a solicitação?</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleFinalizarModalClose}>
                    Não
                  </Button>
                  <Button variant="flat" className={styles.btn} onClick={handleFinalizarSolicitacao}>
                    Sim
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal show={showModalObs} onHide={handleModalObsClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Cancelar solicitação</Modal.Title>
                </Modal.Header>
                <Modal.Body>Ao cancelar a solicitação informe o motivo no campo Observações</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleModalObsClose}>
                    Fechar
                  </Button>
                </Modal.Footer>
              </Modal>

              <ErrorModal
                showErrorModal={showErrorModal}
                setShowErrorModal={setShowErrorModal}
                error={error}
              />
            </Row>

            {
              (chamado?.categoria === 'Manutenção Predial' || chamado?.categoria === 'Manutenção de Elétrica e Iluminação' || chamado?.categoria === 'Manutenção de Água e Esgoto' || chamado?.categoria === 'Manutenção de Ar-Condicionado') && chamado?.subcategoria && (
                <Container>
                  <Row>
                    <p className={styles.manutencao_title}>
                      Em caso de emergência ou agravamento ligue para (21) 97029-6574
                    </p>
                  </Row>
                </Container>
              )
            }

            <Row>
              <Col sm={12} className="mb-4">
                <Form.Group controlId="obs">
                  <Form.Label>Observações:</Form.Label>
                  <Form.Control
                    readOnly={(!isAdmin && !isResp) || (status === 'Finalizado' || status === 'Cancelado')}
                    maxLength={2000}
                    className="border border-secondary"
                    as="textarea"
                    rows={5}
                    name="obs"
                    value={obs || ''}
                    onChange={e => handleObs(e)}
                    ref={obsRef}
                  />
                </Form.Group>
              </Col>
            </Row>

            {(status === 'Aberto' || status === 'Em Andamento') && (
              <div className="text-center mt-3 mb-3">
                <Button variant="flat" className={styles.save_btn} type="submit">
                  Salvar
                </Button>
              </div>
            )}
          </Form>
        </>
      )}
    </Container>
  );
};

export default Chamado;
